/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferralStatusRequest
 */
export interface UpdateReferralStatusRequest {
    /**
     * 
     */
    status: UpdateReferralStatusRequestStatusEnum;
    /**
     * The recipient participant being confirmed. Required when status is 'confirmed', unless the deprecated facility_id is sent instead.
     */
    participant_id?: string;
    /**
     * Deprecated - send participant_id. The facility being confirmed. An external recipient has no facility, so this cannot name one.
     * @deprecated
     */
    facility_id?: string;
    /**
     * Required when status is 'closed'.
     */
    close_reason?: UpdateReferralStatusRequestCloseReasonEnum;
}


/**
 * @export
 */
export const UpdateReferralStatusRequestStatusEnum = {
    Confirmed: 'confirmed',
    Closed: 'closed',
} as const;
export type UpdateReferralStatusRequestStatusEnum = typeof UpdateReferralStatusRequestStatusEnum[keyof typeof UpdateReferralStatusRequestStatusEnum];

/**
 * @export
 */
export const UpdateReferralStatusRequestCloseReasonEnum = {
    ConfirmedElsewhere: 'confirmed_elsewhere',
    Declined: 'declined',
    Lost: 'lost',
    Withdrawn: 'withdrawn',
} as const;
export type UpdateReferralStatusRequestCloseReasonEnum = typeof UpdateReferralStatusRequestCloseReasonEnum[keyof typeof UpdateReferralStatusRequestCloseReasonEnum];


/**
 * Check if a given object implements the UpdateReferralStatusRequest interface.
 */
export function instanceOfUpdateReferralStatusRequest(value: object): value is UpdateReferralStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateReferralStatusRequestFromJSON(json: any): UpdateReferralStatusRequest {
    return UpdateReferralStatusRequestFromJSONTyped(json, false);
}

export function UpdateReferralStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'participant_id': json['participant_id'] == null ? undefined : json['participant_id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'close_reason': json['close_reason'] == null ? undefined : json['close_reason'],
    };
}

export function UpdateReferralStatusRequestToJSON(json: any): UpdateReferralStatusRequest {
    return UpdateReferralStatusRequestToJSONTyped(json, false);
}

export function UpdateReferralStatusRequestToJSONTyped(value?: UpdateReferralStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'participant_id': value['participant_id'],
        'facility_id': value['facility_id'],
        'close_reason': value['close_reason'],
    };
}

